import { ProductTypeQueryParam } from "application/store/models/seleccionarProductoPaso";
import { saveCollegeUser } from "application/store/reducers/CollegeUserReducer";
import { getIsPymeSelector } from "application/store/reducers/SeleccionarProductoReducer";
import { APPLY_COLLEGE } from "application/utils/constants";
import { getCollegeStatusByUserIdService } from "infrastructure/services/get-college-status-by-user-id.services";
import { MixpanelService } from "infrastructure/services/tracker/mixpanel.service";
import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

export function useGetCollegeStatus() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isPymes = useSelector(getIsPymeSelector);

  const getUserId = ({
    documentCountry,
    documentNumber,
    documentType,
  }: {
    documentNumber: string;
    documentCountry: string;
    documentType: string;
  }) => {
    if (
      documentCountry &&
      documentCountry === "858" &&
      documentNumber &&
      documentType &&
      documentType === "CI"
    ) {
      const userId = documentNumber.replace(/[.-]/g, "");
      return userId;
    }
    return "";
  };

  const getCollegeStatusByUserId = useCallback(
    async ({
      documentCountry,
      documentNumber,
      documentType,
      productType,
    }: {
      documentNumber: string;
      documentCountry: string;
      documentType: string;
      productType: ProductTypeQueryParam;
    }) => {
      let userId = getUserId({ documentCountry, documentNumber, documentType });

      if (
        APPLY_COLLEGE &&
        !isPymes &&
        userId &&
        ![ProductTypeQueryParam.PymesParam].includes(productType)
      ) {
        setIsLoading(true);
        MixpanelService.track(
          `Start: get college status by userId`,
          {
            userId,
          },
          true
        );

        try {
          const { data, isSuccess } = await getCollegeStatusByUserIdService({
            userId,
          });

          if (isSuccess && "isInCampaigns" in data) {
            MixpanelService.track(
              `${data.isInCampaigns}: get college status by userId`,
              {
                userId,
              },
              true
            );
            if ( data.isInCampaigns ) {
              dispatch(saveCollegeUser(data));
            }
            return true
          } 
          return false;
        } catch (error) {
          console.error("Error fetching college status:", error);

          MixpanelService.track(
            `Errors Status: get college status by userId`,
            {
              userId,
            },
            true
          );

          return false;
        } finally {
          setIsLoading(false);
        }
      } else {
        return true;
      }
    },
    [dispatch]
  );

  return {
    getCollegeStatusByUserId,
    isLoading,
  };
}
